export default "__VITE_ASSET__BbqrSALr__"